// Every request shares a 60 s timeout, which is fine for JSON but cuts off a
// multipart upload of a large file on an ordinary home uplink — the client
// gives up mid-transfer, the response has no body, and the screen can only
// show a generic "unable to save" (EAD-1580 / EAD-1581). Requests carrying a
// FormData body get a timeout sized for the largest file the UI accepts.
export const DEFAULT_REQUEST_TIMEOUT_MS = 60_000
export const UPLOAD_REQUEST_TIMEOUT_MS = 15 * 60_000

type TimeoutConfig = { data?: unknown; timeout?: number }

export const applyUploadTimeout = <T extends TimeoutConfig>(config: T): T => {
  const isUpload =
    typeof FormData !== "undefined" && config.data instanceof FormData
  const usesDefault =
    config.timeout === undefined ||
    config.timeout === DEFAULT_REQUEST_TIMEOUT_MS

  if (isUpload && usesDefault) {
    config.timeout = UPLOAD_REQUEST_TIMEOUT_MS
  }
  return config
}
